module.exports = __webpack_public_path__ + "img/Amblem2@2x.56a03c38.webp";